import State from './core/State';
import { DateTime } from 'luxon';

const initialState: State = {
  authentication: {
    signedInUser: null,
    token: null,
    fetching: 0,
  },
  availableOrganizations: {
    items: [],
    fetching: 0,
  },
  fatalError: null,
  fullScreenSpinner: {
    necessity: 0,
    loadingMessage: '',
  },
  globalChartSetting: {
    period: {
      type: 'monthly',
      from: DateTime.utc().startOf('month'),
      to: DateTime.utc().endOf('month'),
    },
    subPeriod: {
      type: 'monthly',
      from: DateTime.utc().minus({ months: 1 }).startOf('month'),
      to: DateTime.utc().minus({ months: 1 }).endOf('month'),
    },
    isIncludePrevious: false,
  },
  lastAccessedOrganization: {
    item: null,
    fetching: 0,
  },
  location: {
    pathname: '/',
    search: '',
  },
  nonFatalErrors: [],
  sales: {
    data: null,
    fetching: 0,
  },
  salesByVisitor: {
    data: null,
    fetching: 0,
  },
  salesBySegments: {
    data: null,
    fetching: 0,
  },
  salesByCategory: {
    data: null,
    fetching: 0,
  },
  salesByProduct: {
    data: null,
    fetching: 0,
  },
  businessSummary: {
    data: null,
    fetching: 0,
  },
  usersSummary: {
    data: null,
    fetching: 0,
  },
  productsSummary: {
    data: null,
    fetching: 0,
  },
  snackbar: {
    message: null,
    messageValues: {},
    action: null,
    severity: 'init',
    actionValues: {},
    isRaw: false,
    onClickAction: null,
  },
  visitor: {
    data: null,
    fetching: 0,
  },
  purchasers: {
    data: null,
    fetching: 0,
  },
  purchaseRates: {
    data: null,
    fetching: 0,
  },
  visitorsBySession: {
    data: null,
    fetching: 0,
  },
  visitorsByPv: {
    data: null,
    fetching: 0,
  },
  visitorsBySegments: {
    data: null,
    fetching: 0,
  },
  order: 'desc',
  orderBy: 'value',
  liftUpReportChart: {
    data: null,
    fetching: 0,
  },
  indexReportChart: {
    data: null,
    fetching: 0,
  },
  indexReportDimension: {
    data: null,
    fetching: 0,
  },
  coverageReportChart: {
    data: null,
    fetching: 0,
  },
  liftReports: {
    data: null,
    fetching: 0,
  },
  customReport: {
    data: null,
    fetching: 0,
  },
  selectedChartGroup: {
    data: 0,
  },
  goals: {
    data: null,
    fetching: 0,
  },
  selectedGoalId: {
    data: null,
    fetching: 0,
  },
  indexReportDimensionKeyState: {
    data: null,
  },
  coverageReportDimensionKeyState: {
    data: null,
  },
  liftUpReportDimensionKeyState: {
    data: null,
  },
  indexReportFrequency: {
    data: null,
  },
  coverageReportFrequency: {
    data: null,
  },
  liftUpReportFrequency: {
    data: null,
  },
  liftReportChartSetting: {
    period: {
      type: 'daily',
      from: DateTime.utc().startOf('month'),
      to: DateTime.utc().endOf('month'),
    },
  },
  customReportChartSetting: {
    period: {
      type: 'daily',
      from: DateTime.utc().startOf('month'),
      to: DateTime.utc().endOf('month'),
    },
  },
  pagePreviews: {
    data: null,
    fetching: 0,
  },
  currentPagePreview: {
    data: null,
    fetching: 0,
  },

  createdPreviewId: {
    data: null,
    fetching: 0,
  },

  siteScript: {
    data: null,
    fetching: 0,
  },

  rootDomains: {
    data: null,
    fetching: 0,
  },

  siteJsPermission: {
    data: null,
    fetching: 0,
  },

  speculationRule: {
    data: null,
    fetching: 0,
  },

  createReturnComment: {
    fetching: 0,
  },

  createNewPosition: {
    fetching: 0,
  },

  appendPreviewPage: {
    fetching: 0,
    uploadError: null,
  },

  updateComment: {
    fetching: 0,
  },
};

export default initialState;
